import { ExpandableItem } from "common/components/ExpandableItem";
import { FeedbackItem } from "domain/feedback/FeedbackItem";
import React from "react";

interface Props {
  id: string;
  title: string;
  canAnswer: boolean;
  isQuestion: boolean;
  answerButtonTitle: string;
}

export const FeedbackListItem: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  title,
  canAnswer,
  isQuestion,
  answerButtonTitle,
}) => {
  return (
    <ExpandableItem
      title={title}
      content={
        <FeedbackItem
          feedbackId={id}
          canAnswer={canAnswer}
          isQuestion={isQuestion}
          answerButtonTitle={answerButtonTitle}
        />
      }
    />
  );
};
